"use client";
import { Avatar, Box, Center, Input, InputProps } from "@chakra-ui/react";
import { useState } from "react";
import { FaUpload } from "react-icons/fa";

export interface UploadAvatarProps extends Omit<InputProps, "type"> {
  size?: string;
  placeholder: string;
  onChangeImage: (props: {
    imageToUpload: File | null;
    picture: string;
  }) => void;
}

export const UploadAvatar = ({
  size,
  placeholder,
  onChangeImage,
  ...rest
}: UploadAvatarProps) => {
  const [image, setImage] = useState<string>(placeholder);
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return;
    }
    const imageToUpload = e?.target?.files?.[0];

    const reader = new FileReader();
    reader.onload = (avatar) => {
      if (avatar?.target?.result) {
        setImage(avatar.target.result as string);
        onChangeImage({
          imageToUpload,
          picture: avatar.target.result as string,
        });
      }
    };
    reader.readAsDataURL(imageToUpload);
  };
  return (
    <Box
      color="rgba(0,0,0,0.5)"
      sx={{
        display: "flex",
        justifyContent: "center",
        w: size,
        h: size,
        borderRadius: "50%",
        cursor: "pointer",
        backgroundColor: "blueGray.50",
        overflow: "hidden",
        position: "relative",
        _hover: {
          color: "white",
          ".upload-avatar-icon": {
            backgroundColor: "rgba(0,0,0,0.5)",
          },
        },
      }}
    >
      <Input
        type="file"
        accept={"image/*"}
        w={size}
        h={size}
        sx={{
          display: "block",
          opacity: 0,
          borderRadius: "50%",
          position: "absolute",
          cursor: "pointer",
          zIndex: 2,
        }}
        onChange={handleImageChange}
        {...rest}
      />
      <Avatar zIndex={1} src={image} w={size} h={size} />
      <Center
        className="upload-avatar-icon"
        position="absolute"
        top="0"
        right="0"
        bottom="0"
        left="0"
        zIndex={1}
      >
        <Box as={FaUpload} h={`calc(${size} / 4)`} w={`calc(${size} / 4)`} />
      </Center>
    </Box>
  );
};
